import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {Router} from '@node_modules/@angular/router';

@Injectable()
export class UrlService {
  private previousUrl: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public previousUrl$: Observable<string> = this.previousUrl.asObservable();

  constructor(
    private router: Router,
  ) {
    //
  }

  setPreviousUrl(previousUrl: string) {
    this.previousUrl.next(previousUrl);
  }

  navigateToPreviousUrl(): void {
    let prevUrl = null;

    this.previousUrl$.subscribe((previousUrl: string) => {
      prevUrl = previousUrl;
    });

    if (prevUrl) {
      this.router.navigate([prevUrl]);
    }
  }
}
